import dynamic from 'next/dynamic';
import { getLayout } from '@components/layouts/layout';
import { isMobileOnly } from 'react-device-detect';
export { getServerSideProps } from '@framework/ssr/search';
import { getLayout as getSiteLayoutMobile } from '@components/layouts/layout-mobile';

const Search = dynamic(() => import('@framework/search/search'));

export default function SearchPage() {
  return <Search />;
}

const getLayoutMobile = (page: React.ReactElement) =>
  getSiteLayoutMobile(
    <>{page}</>
  );

SearchPage.getLayout = isMobileOnly ? getLayoutMobile : getLayout;
